import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const ShrineOfReflection = {
  id: '50',
  name: "Shrine of Reflection",
  width: 6,
  height: 3,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Shrine_Of_Reflection',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Shrine_of_Reflection',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.LIGHT_INFANTRY_HIT_POINT_MOD,
      EffectAmount.asCallbackWithLevel(
        (level) => {
          if (level <= 2) return 0;
          if (level <= 9) return 1.5;
          if (level <= 16) return 2.5;
          if (level <= 23) return 4;
          if (level <= 29) return 5.5;
          if (level <= 37) return 7;
          if (level <= 38) return 8.5;
          if (level <= 39) return 8.6;
          if (level <= 40) return 8.7;
          return 8.7 + 0.1 * (level - 41);
        }
      ),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput
        .asCallbackWithLevel(
          (level) => level <= 4 ? 0 : 1
        )
        .withOutput(ProductionOutputType.CHEST)
        .withDescription('Produce chest which can include food or regular puzzles')
      ,
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          20,20,20,20,20,25,25,30,30,30,35,35,35,40,40,40,40,40,40,45,45,50,50,50,60,60,70,70,70,70,70,80,80,80,90,90,100,100,110,113,115,118,120,123,125,128,130,133,135,138,140,143,145,148,150,153,155,158,160,163
        ],
        bronzeAge: [
          30,30,30,30,30,38,38,45,45,45,53,53,53,60,60,60,60,60,60,68,68,75,75,75,90,90,105,105,105,105,105,120,120,120,135,135,150,150,165,171,174,178,182,186,190,193,197,201,205,209,212,216,220,224,228,231,235,239,243,247
        ],
        minoanEra: [
          40,40,40,40,40,50,50,60,60,60,70,70,70,80,80,80,80,80,80,90,90,100,100,100,120,120,140,140,140,140,140,160,160,160,180,180,200,200,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325
        ],
        classicGreece: [
          50,50,50,50,50,63,63,75,75,75,88,88,88,99,99,99,99,99,99,120,120,130,130,130,150,150,180,180,180,180,180,200,200,200,230,230,250,250,280,300,307,315,322,330,337,345,352,360,367,375,382,390,397,405,412,420,427,435,442,450
        ],
        earlyRome: [
          60,60,60,60,60,75,75,90,90,90,105,105,105,120,120,120,120,120,120,135,135,150,150,150,180,180,210,210,210,210,210,240,240,240,270,270,300,300,330,338,345,353,360,368,375,383,390,398,405,413,420,428,435,443,450,458,465,473,480,488
        ],
        romanEmpire: [
          90,90,90,90,90,110,110,130,130,130,150,150,150,170,170,170,170,170,170,200,200,220,220,220,250,250,300,300,300,300,300,340,340,340,390,390,420,420,470,500,512,525,537,550,562,575,587,600,612,625,637,650,662,675,687,700,712,725,737,750
        ],
        byzantineEra: [
          90,90,90,90,90,110,110,130,130,130,150,150,150,170,170,170,170,170,170,200,200,220,220,220,250,250,300,300,300,300,300,340,340,340,390,390,420,420,470,500,512,525,537,550,562,575,587,600,612,625,637,650,662,675,687,700,712,725,737,750
        ],
        ageOfTheFranks: [
          90,90,90,90,90,110,110,130,130,130,150,150,150,170,170,170,170,170,170,200,200,220,220,220,250,250,300,300,300,300,300,340,340,340,390,390,420,420,470,500,512,525,537,550,562,575,587,600,612,625,637,650,662,675,687,700,712,725,737,750
        ],
        feudalAge: [
          90,90,90,90,90,110,110,130,130,130,150,150,150,170,170,170,170,170,170,200,200,220,220,220,250,250,300,300,300,300,300,340,340,340,390,390,420,420,470,500,512,525,537,550,562,575,587,600,612,625,637,650,662,675,687,700,712,725,737,750
        ],
        iberianEra: [
          90,90,90,90,90,110,110,130,130,130,150,150,150,170,170,170,170,170,170,200,200,220,220,220,250,250,300,300,300,300,300,340,340,340,390,390,420,420,470,500,512,525,537,550,562,575,587,600,612,625,637,650,662,675,687,700,712,725,737,750
        ],
        kingdomOfSicily: [
          90,90,90,90,90,110,110,130,130,130,150,150,150,170,170,170,170,170,170,200,200,220,220,220,250,250,300,300,300,300,300,340,340,340,390,390,420,420,470,500,512,525,537,550,562,575,587,600,612,625,637,650,662,675,687,700,712,725,737,750
        ],
        highMiddleAges: [
          90,90,90,90,90,110,110,130,130,130,150,150,150,170,170,170,170,170,170,200,200,220,220,220,250,250,300,300,300,300,300,340,340,340,390,390,420,420,470,500,512,525,537,550,562,575,587,600,612,625,637,650,662,675,687,700,712,725,737,750
        ],
        earlyGothicEra: [
          90,90,90,90,90,110,110,130,130,130,150,150,150,170,170,170,170,170,170,200,200,220,220,220,250,250,300,300,300,300,300,340,340,340,390,390,420,420,470,500,512,525,537,550,562,575,587,600,612,625,637,650,662,675,687,700,712,725,737,750
        ],
        lateGothicEra: [
          90,90,90,90,90,110,110,130,130,130,150,150,150,170,170,170,170,170,170,200,200,220,220,220,250,250,300,300,300,300,300,340,340,340,390,390,420,420,470,500,512,525,537,550,562,575,587,600,612,625,637,650,662,675,687,700,712,725,737,750
        ],
      }).withOutput(ProductionOutputType.ALL_CURRENT_ERA_GOODS),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          0,20,20,25,25,25,30,30,30,30,30,30,25,25,25,40,40,40,50,50,60,60,60,60,60,70,70,70,80,80,90,90,90,100,100,110,112,115,117,120,122,125,127,130,132,135,137,140,142,145,147,150,152,155,157,160,162,165,167,170
        ],
        bronzeAge: [
          0,30,30,38,38,38,45,45,45,45,45,45,53,53,53,60,60,60,75,75,90,90,90,90,90,105,105,105,120,120,135,135,135,150,150,165,170,174,178,182,185,189,193,197,201,204,208,212,216,220,223,227,231,235,239,242,246,250,254,258
        ],
        minoanEra: [
          0,36,36,45,45,45,54,54,54,54,54,54,63,63,63,72,72,72,90,90,108,108,108,108,108,126,126,126,144,144,162,162,162,180,180,200,205,210,215,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320
        ],
        classicGreece: [
          0,54,54,69,69,69,81,81,81,81,81,81,96,96,96,108,108,108,135,135,162,162,162,162,162,189,189,189,216,216,243,243,243,270,270,300,307,315,322,330,337,345,352,360,367,375,382,390,397,405,412,420,427,435,442,450,457,465,472,480
        ],
        earlyRome: [
          0,65,65,81,81,81,98,98,98,98,98,98,114,114,114,130,130,130,132,132,195,195,195,195,195,227,227,227,260,260,292,292,292,324,324,360,369,378,387,396,405,414,423,432,441,450,459,468,477,486,495,504,513,522,531,540,549,558,567,576
        ],
        romanEmpire: [
          0,70,70,90,90,90,110,110,110,110,110,110,120,120,120,140,140,140,170,170,210,210,210,210,210,240,240,240,270,270,310,310,310,340,340,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560,570,580,590,600,610,620
        ],
        byzantineEra: [
          0,70,70,90,90,90,110,110,110,110,110,110,120,120,120,140,140,140,170,170,210,210,210,210,210,240,240,240,270,270,310,310,310,340,340,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560,570,580,590,600,610,620
        ],
        ageOfTheFranks: [
          0,70,70,90,90,90,110,110,110,110,110,110,120,120,120,140,140,140,170,170,210,210,210,210,210,240,240,240,270,270,310,310,310,340,340,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560,570,580,590,600,610,620
        ],
        feudalAge: [
          0,70,70,90,90,90,110,110,110,110,110,110,120,120,120,140,140,140,170,170,210,210,210,210,210,240,240,240,270,270,310,310,310,340,340,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560,570,580,590,600,610,620
        ],
        iberianEra: [
          0,70,70,90,90,90,110,110,110,110,110,110,120,120,120,140,140,140,170,170,210,210,210,210,210,240,240,240,270,270,310,310,310,340,340,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560,570,580,590,600,610,620
        ],
        kingdomOfSicily: [
          0,70,70,90,90,90,110,110,110,110,110,110,120,120,120,140,140,140,170,170,210,210,210,210,210,240,240,240,270,270,310,310,310,340,340,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560,570,580,590,600,610,620
        ],
        highMiddleAges: [
          0,70,70,90,90,90,110,110,110,110,110,110,120,120,120,140,140,140,170,170,210,210,210,210,210,240,240,240,270,270,310,310,310,340,340,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560,570,580,590,600,610,620
        ],
        earlyGothicEra: [
          0,70,70,90,90,90,110,110,110,110,110,110,120,120,120,140,140,140,170,170,210,210,210,210,210,240,240,240,270,270,310,310,310,340,340,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560,570,580,590,600,610,620
        ],
        lateGothicEra: [
          0,70,70,90,90,90,110,110,110,110,110,110,120,120,120,140,140,140,170,170,210,210,210,210,210,240,240,240,270,270,310,310,310,340,340,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560,570,580,590,600,610,620
        ],
      }).withOutput(ProductionOutputType.ALL_PREVIOUS_ERA_GOODS),
    ),
  ]),
};

export default ShrineOfReflection;
